import { styled } from "@mui/material/styles";
const PriceQuotationMain = styled("div")(({ theme }) => ({
  height: "100vh",
  minHeight: "100vh",
  width: "100%",
  position: "relative",
  zIndex: 3,
}));
// const PriceQuotationWrap = styled("div")(({ theme }) => ({
//   padding: "40px",
//   paddingTop: "50px",
//   paddingBottom: "200px",
//   paddingLeft: "25px",
// }));

const PackageDeliveryBox = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "30px",
  left: "10%",
  transform: "translateX(-10%)",
  width: "75%",
  maxWidth: "450px",
  zIndex: 1,
  backgroundColor: "#fff",
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  padding: "35px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: "100%",
    top: "inherit",
    bottom: 0,
    boxShadow: "0px -1px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "20px 20px 0px 0px",
    marginBottom: "0px",
    padding: "20px",
  },
}));
const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "22px",
    lineHeight: "130%",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& .countItem": {
    marginTop: "35px",
    fontWeight: 600,
  },
  "& .address": {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    "& span": {
      fontFamily: theme.typography.fontFamily,
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "18px",
      lineHeight: "18px",
      color: "#0B0B0B",
    },
    "& p": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "16px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
      marginLeft: "10px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    "& h6": {
      textAlign: "center",
    },
    "& .countItem": {
      textAlign: "left",
      fontSize: "16px",
      marginTop: "14px",
    },
    "& .address": {
      marginBottom: "10px",
      "& span": {
        fontSize: "14px",
      },
      "& p": {
        fontSize: "14px",
      },
    },
  },
}));

const PriceMain = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& .pricemain": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "18px",
      lineHeight: "130%",
      color: "#191D31",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .timemain": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "18px",
      lineHeight: "130%",
      color: "#191D31",
      fontFamily: theme.typography.fontFamily,
    },
    "& p": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "180%",
      textAlign: "right",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  [theme.breakpoints.down("sm")]: {
    "& span": {
      fontSize: "14px",
    },
  },
}));

const ButtonMainSec = styled("div")(({ theme }) => ({
  marginTop: "40px",
  "& button": {
    marginTop: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: "20px",
  },
}));

export {
  PriceQuotationMain,
  PackageDeliveryBox,
  Maincontant,
  PriceMain,
  ButtonMainSec,
};
